import { render, staticRenderFns } from "./UsuariosBloqueados.vue?vue&type=template&id=c15c94ec&"
import script from "./UsuariosBloqueados.vue?vue&type=script&lang=js&"
export * from "./UsuariosBloqueados.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports